import { render, staticRenderFns } from "./DatePicker2.vue?vue&type=template&id=0871017f&scoped=true&"
import script from "./DatePicker2.vue?vue&type=script&lang=js&"
export * from "./DatePicker2.vue?vue&type=script&lang=js&"
import style0 from "./DatePicker2.vue?vue&type=style&index=0&id=0871017f&scoped=true&lang=scss&"
import style1 from "./DatePicker2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871017f",
  null
  
)

export default component.exports